import { CheckIcon } from "./icons";
import "../../../styles/panel/user/TemplateStep.css";
import { useEffect, useState } from "react";
import { fetchTemplates } from "../../../api/storeRequest";

function EyeIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none">
      <path
        d="M1.5 12S5 5 12 5s10.5 7 10.5 7-3.5 7-10.5 7S1.5 12 1.5 12Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="12"
        cy="12"
        r="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function TemplateStep({ template, setTemplate }) {
  const [templates, setTemplates] = useState([]);

  useEffect(() => {
    const load = async () => {
      const t = await fetchTemplates();
      setTemplates(t?.data || []);
    };
    load();
  }, []);

  return (
    <>
      <h3 className="request-step-title">قالب سایت</h3>
      <p className="request-step-sub">
        قالب مورد نظرت رو انتخاب کن، بعداً هم قابل تغییره
      </p>
      <div className="template-grid">
        {templates.map((t) => (
          <div
            key={t.template_id}
            className={`template-card${template?.id === t.template_id ? " selected" : ""}`}
            onClick={() => setTemplate({ id: t.template_id, name: t.title })}
          >
            <div className="template-preview">
              <img
                src={t.thumbnail}
                alt={t.title}
                className="template-preview-img"
                loading="lazy"
              />

              <div className="template-preview-overlay">
                <button
                  type="button"
                  className="template-preview-eye"
                  aria-label="مشاهده دمو"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (t.preview_url) {
                      window.open(
                        t.preview_url,
                        "_blank",
                        "noopener,noreferrer",
                      );
                    }
                  }}
                >
                  <EyeIcon />
                </button>
              </div>
            </div>
            <div className="template-check">
              <CheckIcon />
            </div>
            <div className="template-name">{t.title}</div>
            <div className="template-desc">{t.description}</div>
          </div>
        ))}
      </div>
    </>
  );
}

export function isTemplateStepValid(template) {
  return !!template;
}
